import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";

import { EyeIcon, PencilIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { Tooltip } from "@mui/material";

import ErrorToast from "@components/Common/ErrorTost";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";

import store, {
    setIsLoading,
    setSelectedLogo,
    setArchivedData,
    setIsArchiveModalOpened,
    setIsHistoryModalOpened,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setDataIsUpdated,
} from "../store";

import { store as useStore } from "../../../../components/VerticalLayout/store";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import {
    activeLogo,
    archiveLogo,
    handleStateChange,
    isSaleSupportArchived,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

export function CustomIcons({
    selectedRowData,
    setSelectedRows,
    setShopId,
    setLogo,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    isAddLogoClicked,
    setIsAddLogoClicked,
    isLogoArchived,
    setLocalFilterActive,
    setIsConsult,
    setDataState,
}: any) {
    const {
        numberActive,
        numberArchived,
        shopsLogoData,
        isArchiveModalOpened,
        isHistoryModalOpened,
        isActionsClicked,
        isEdited,
        modify,
        archivedLogoFranchise,
        isLoading,
        logoData,
    } = useSnapshot(store);
    const { franchiseID, userID, oneShop, operatorID, shopID } = useSnapshot(
        useStore
    );
    const { fetchGlobal } = useFetchGlobal();
    const [choiceState, setLogoState] = React.useState<boolean>(
        selectedRowData.selectedRow.isActive
    );
    const [isClicked, setIsClicked] = React.useState<boolean>(false);

    const { t } = useTranslation();
    const shopId = oneShop ? shopID : 0;
    const uuidUser = localStorage.getItem("uuidUser");

    let dataArchive: any[] = [];

    if (!oneShop) {
        dataArchive = ArchivedLogo();
    } else {
        dataArchive = ArchivedLogoFranchise();
    }

    function ArchivedLogoFranchise() {
        let idsAssociated: any[] = [];
        if (
            archivedLogoFranchise.othersData.dataFranchiseArchive !== undefined
        ) {
            archivedLogoFranchise.othersData.dataFranchiseArchive.data.forEach(
                (element: any) => {
                    idsAssociated.push(element.Id);
                }
            );
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }

    function ArchivedLogo() {
        let idsAssociated: any[] = [];
        if (shopsLogoData !== undefined) {
            Object.values(shopsLogoData).forEach((element: any) => {
                element?.subRows.forEach((el: any) => {
                    idsAssociated.push(el.Id);
                });
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }

    function handleTrashButtonClicked(selectedRow: any) {
        let idsAssociated: any = [];
        shopsLogoData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        });
        if (idsAssociated.includes(selectedRow.Id) && !oneShop) {
            ErrorToast(
                `${t(
                    "Please note that you cannot archive an item assigned to stores."
                )!}`
            );
            setDataIsUpdated(true);
            setIsLoading(false);
        } else {
            setArchivedData(selectedRowData);
            setIsArchiveModalOpened!(!isArchiveModalOpened);
            archiveLogo(
                selectedRow,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                numberArchived,
                numberActive,
                setIsClicked,
                fetchGlobal
            );
        }
    }

    return (
        <React.Fragment>
            {selectedRowData.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === false ? (
                        <Tooltip title={t("To consult")}>
                            <div>
                                {" "}
                                <ConsultSvgIcon
                                    className="pointer__clz afa_icn_toConsult"
                                    height={35}
                                    width={35}
                                    style={{
                                        cursor: "pointer",
                                        position: "relative",
                                        bottom: "5px",
                                    }}
                                    fill="black"
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsEdited(false);
                                                setShopId(
                                                    selectedRowData.selectedRow
                                                        .shopId
                                                );
                                                setLogo(
                                                    selectedRowData.selectedRow
                                                );

                                                setIsAddLogoClicked(true);

                                                setLocalFilterActive(false);
                                            });
                                        } else {
                                            setShopId(
                                                selectedRowData.selectedRow
                                                    .shopId
                                            );
                                            setLogo(
                                                selectedRowData.selectedRow
                                            );

                                            setIsAddLogoClicked(true);

                                            setLocalFilterActive(false);
                                        }
                                        setIsConsult(true);
                                    }}
                                />
                            </div>
                        </Tooltip>
                    ) : null}
                    {modify === true ? (
                        <>
                            <Tooltip title={isLogoArchived ? "" : t("Edit")}>
                                <div>
                                    <PencilIcon
                                        onClick={() => {
                                            if (isEdited === true) {
                                                setIsActionsClicked(
                                                    !isActionsClicked
                                                );
                                                setActions(() => {
                                                    setIsEdited(false);
                                                    setShopId(
                                                        selectedRowData
                                                            .selectedRow.shopId
                                                    );
                                                    setLogo(
                                                        selectedRowData.selectedRow
                                                    );

                                                    setIsAddLogoClicked(true);

                                                    setLocalFilterActive(false);
                                                });
                                            } else {
                                                setShopId(
                                                    selectedRowData.selectedRow
                                                        .shopId
                                                );
                                                setLogo(
                                                    selectedRowData.selectedRow
                                                );

                                                setIsAddLogoClicked(true);

                                                setLocalFilterActive(false);
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        style={{ cursor: "pointer" }}
                                        className={`${classnames(
                                            "pointer__clz cmn_icn_FRedit",
                                            {
                                                "not-allowed-icon__clz":
                                                    isLogoArchived || isLoading,
                                            },
                                            oneShop ? "mr-2" : "ml-3"
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            {oneShop && (
                                <Tooltip
                                    title={
                                        isLogoArchived
                                            ? ""
                                            : choiceState === false
                                            ? t("Activate")
                                            : t("Unactivate")
                                    }
                                >
                                    <div>
                                        <ReactSwitch
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            handleDiameter={26}
                                            offColor="#f7b4b8"
                                            offHandleColor="#E30613"
                                            checked={choiceState}
                                            onChange={async (e: boolean) => {
                                                setMessage(
                                                    choiceState
                                                        ? t(
                                                              "Caution, the Logo may be used by other modules.\n Would you like to confirm the deactivation of the selected Logo?"
                                                          )
                                                        : t(
                                                              "Would you like to confirm the activation of the selected Logo?"
                                                          )
                                                );
                                                setYesFunction(() => {
                                                    setIsLoading(true);
                                                    setLogoState(!choiceState);
                                                    handleStateChange(
                                                        e,
                                                        selectedRowData,
                                                        logoData,
                                                        userID,
                                                        franchiseID,
                                                        operatorID,
                                                        uuidUser,
                                                        choiceState,
                                                        fetchGlobal
                                                    );

                                                    setDataState({
                                                        id:
                                                            selectedRowData
                                                                ?.selectedRow
                                                                .Id,
                                                        state: !choiceState,
                                                    });
                                                });

                                                setActivationDeactivationMessageModalOpened(
                                                    true
                                                );
                                            }}
                                            onColor="#c2eddd"
                                            onHandleColor="#34C38F"
                                            width={50}
                                            height={20}
                                            className={`${classnames(
                                                "lgo_icn_BTiconEdit  lgo_icn_BTiconEnableDisable",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isLogoArchived ||
                                                        isLoading,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}

                            {!isLogoArchived ? (
                                <Tooltip title={t("Archive")}>
                                    <div>
                                        <TrashIcon
                                            onClick={() => {
                                                setIsLoading(true);
                                                if (isEdited === true) {
                                                    setIsLoading(false);
                                                    setIsActionsClicked(
                                                        !isActionsClicked
                                                    );
                                                    setActions(() => {
                                                        setIsEdited(false);
                                                        setLogo(
                                                            selectedRowData.selectedRow
                                                        );
                                                        setIsAddLogoClicked(
                                                            false
                                                        );
                                                        handleTrashButtonClicked(
                                                            selectedRowData.selectedRow
                                                        );
                                                    });
                                                    // setIsLoading(false);
                                                } else {
                                                    setIsAddLogoClicked(false);
                                                    setLogo(
                                                        selectedRowData.selectedRow
                                                    );

                                                    handleTrashButtonClicked(
                                                        selectedRowData.selectedRow
                                                    );
                                                    // setIsLoading(false);
                                                }
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{ cursor: "pointer" }}
                                            className={`${classnames(
                                                "pointer__clz  cmn_icn_FRarchived",
                                                oneShop ? "mr-2" : "ml-3",
                                                {
                                                    "not-allowed-icon__clz": isLoading,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    title={
                                        dataArchive.includes(
                                            selectedRowData.selectedRow.Id
                                        ) && oneShop
                                            ? ""
                                            : t("Unarchive")
                                    }
                                >
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            style={{ cursor: "pointer" }}
                                            onClick={async () => {
                                                setIsLoading(true);
                                                setLogo(
                                                    selectedRowData.selectedRow
                                                );
                                                setSelectedRows(
                                                    selectedRowData
                                                );
                                                let isArchived = await isSaleSupportArchived(
                                                    selectedRowData,
                                                    userID,
                                                    shopId,
                                                    franchiseID,
                                                    fetchGlobal
                                                );

                                                if (isArchived === true) {
                                                    ErrorToast(
                                                        `${t(
                                                            "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                                        )!}`
                                                    );
                                                    setIsLoading(false);
                                                } else if (
                                                    dataArchive.includes(
                                                        selectedRowData
                                                            .selectedRow.Id
                                                    ) &&
                                                    !oneShop
                                                ) {
                                                    setIsModalConfirmationOpened(
                                                        !isModalConfirmationOpened
                                                    );
                                                    setIsLoading(false);
                                                } else {
                                                    activeLogo(
                                                        selectedRowData,
                                                        userID,
                                                        franchiseID,
                                                        operatorID,
                                                        uuidUser,
                                                        oneShop,
                                                        setDataIsUpdated,
                                                        setIsClicked,
                                                        numberActive,
                                                        numberArchived,
                                                        fetchGlobal
                                                    );
                                                    setIsLoading(false);
                                                }
                                            }}
                                            className={`${classnames(
                                                "pointer__clz cmn_icn_FRunarchive",
                                                {
                                                    "not-allowed-icon__clz":
                                                        (dataArchive.includes(
                                                            selectedRowData
                                                                .selectedRow.Id
                                                        ) &&
                                                            oneShop) ||
                                                        isLoading ||
                                                        isClicked,
                                                },
                                                oneShop ? "mr-2" : "ml-3"
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                className={classnames(
                                    "pointer__clz cmn_icn_FRhistory",
                                    oneShop ? "mr-2" : "ml-3",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            setIsEdited(false);
                                            setIsAddLogoClicked(false);
                                            setIsHistoryModalOpened(
                                                !isHistoryModalOpened
                                            );

                                            setSelectedLogo([
                                                {
                                                    [selectedRowData.selectedRow
                                                        .shopId]:
                                                        selectedRowData
                                                            .selectedRow.Id,
                                                },
                                            ]);
                                        });
                                    } else {
                                        setIsHistoryModalOpened(
                                            !isHistoryModalOpened
                                        );
                                        setSelectedLogo([
                                            {
                                                [selectedRowData.selectedRow
                                                    .shopId]:
                                                    selectedRowData.selectedRow
                                                        .Id,
                                            },
                                        ]);
                                    }
                                }}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
